






























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ICustomer, IStaff, IWhoAmI, IWorkOrderFilter, TransferStatus } from '@/interfaces';
import { makeWorkOrderFilter } from '@/utils';
import { GetCustomer, SearchCustomers } from "@/api";
import { RimRepairAutocompleteComponent } from "@/components/common";
  
import DatePicker from './date-picker.vue'
import { Getter } from "vuex-class";

@Component({
	components:{
		RimRepairAutocompleteComponent, 
		DatePicker
	}
})
export default class WorkOrderFilterComponent extends Vue {

	/**
	 *
	 */
	constructor() {
		super();
		// this.filter = {};	
	}

	mounted(){
			this.Techs = this.$store.getters["AppModule/staff"]
			.sort((a:IStaff, b:IStaff)=>{
				return a.Initials.localeCompare(b.Initials);
			});

			this.Status.push({ N: 'Any', V: null });
			this.Status.push({ N: 'Completed', V: true });
			this.Status.push({ N: 'Not Completed', V: false });

			/*
			BY DEFAULT, SET ASSIGNED-TO THE LOGGED IN USER.
			*/
			this.value.SentTo = this.Myself.UserID;

			// for (var enumMember in TransferStatus) {
			// 	var isValueProperty = parseInt(enumMember, 10) >= 0
			// 	if (isValueProperty) {
			// 			// console.log("enum: ", TransferStatus[enumMember], enumMember);
			// 			this.Status.push({ 
			// 				N: TransferStatus[enumMember], 
			// 				V: enumMember });
   		// 	}
			// }

	}

	@Prop()
	public value: IWorkOrderFilter ;

  @Getter("user", { namespace: "AppModule" })
  public Myself: IWhoAmI;

	public Techs: IStaff[] = [];
	public Status: any[] = [];

	public isFilering: boolean = false;
	public menu1: boolean=false;
	public menu2: boolean=false;

	public toggleFiltering(): void {
		this.isFilering = !this.isFilering;
	}

	public Filter(): void {
		// this.isFilering = !this.isFilering;
		this.$emit('filter', this.value);
	}

	public GetTechName(s:IStaff): string{
 		var rval = `[${s.Initials}] ${s.FName} ${s.LName}`;
		return rval;
	}

	// public ClearStatus():void{
	// 	this.value.TransferStatus = null;
	// 	(this.$refs.statussel as any).blur();
	// }


	public ClearTech1():void{
		this.value.SentBy = null;
		(this.$refs.techsel1 as any).blur();
	}

	public ClearTech2():void{
		this.value.SentTo = null;
		(this.$refs.techsel2 as any).blur();
	}

	public FiltersUpdated():void{
		/* DOES NOTHING FOR NOW... 		*/
	}

  async searchCustomerFn(value: string): Promise<ICustomer[]> {
      const resp = await SearchCustomers(value, 0, 5);
      return resp.Ok ? resp.Results.Customers : [];
  }

  // async searchCustomerFn(value: string | number): Promise<ICustomer[]> {
  //   if (typeof value === "number") {
  //     const resp = await GetCustomer(value);
  //     return resp.Ok ? [resp.Customer] : [];
  //   } else {
  //     const resp = await SearchCustomers(value, 0, 5);
  //     return resp.Ok ? resp.Results.Customers : [];
  //   }
  // }


	updateCustomer(customer: ICustomer) {
    	this.value.CustomerID	= customer.RecordID;
	}




}


